import React, { ReactElement } from 'react';
import { useParams } from 'react-router-dom';
import MapPage from '../../map';
import ListPage from '../../list/components/list-page';
import { COORD_PATTERN, MEDLEM_ID_PATTERN, NODE_ID_PATTERN } from '../../../../utils';
import { UseParams } from '../../../../types';
import DetailPageContainer from '../../details/containers/detail-page-container';

export function SlugRouter(): ReactElement {
  const { slug }: UseParams = useParams();
  switch (true) {
    case COORD_PATTERN.test(slug):
      return <MapPage />;
    case NODE_ID_PATTERN.test(slug):
      return <DetailPageContainer />;
    case MEDLEM_ID_PATTERN.test(slug):
      return <DetailPageContainer />;
    default:
      return <ListPage />;
  }
}
